<h3 sidenav-title>{{ 'Advanced Filters' }}</h3>

<sidenav-content>
    <form [formGroup]="formGroup">
        <div class="form-group">
            <sidenav-label>{{ 'Region' }}</sidenav-label>
            <mat-form-field appearance="outline">
                <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select State' }}" formControlName="state">
                    <mat-option [value]="'all'">{{ 'All States' }}</mat-option>
                    <mat-option *ngFor="let state of states | keyvalue: originalOrder" [value]="state.value.abbreviation">
                        {{ state.value.region }} ({{ state.value.abbreviation }})
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</sidenav-content>

<sidenav-actions>
    <button mat-flat-button disableRipple color="primary" (click)="applyFilters()">{{ 'Apply Filters' }}</button>
    <button-spacer></button-spacer>
    <button mat-flat-button disableRipple color="accent" sidenav-close>{{ 'Close' }}</button>
</sidenav-actions>
